// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3TCv5","info":"UpdateTermsInfo_info__3Fgvy"};